import helpers from '@/store/helpers'

const Menu = {
  namespaced: true,
  state: {
    menus: null
  },
  mutations: {
    loadMenu (state, payload) {
      state.menus = Object.assign({}, payload)
    },
    reset (state, payload) {
      state.menus = null
    }
  },
  actions: {
    refresh: (context, payload) => helpers.refresh(context, payload,
      {backend: 'home', method: 'getAuthMenuAccessUsingGET', mutation: 'loadMenu', state: 'menus'}),
    list: (context, payload) => helpers.list(context, payload, {action: 'refresh', state: 'menus'}),
    reset: (context, payload) => context.commit('reset', payload)
  }
}

export default Menu



// WEBPACK FOOTER //
// ./src/store/master/Menu.js